import type {
  SignalMetadataDto,
  SignalReferenceDto,
} from '@/feature/signals/api.types';

export const resolveSignalNames = (
  baseSignalName: string,
  metadata: SignalMetadataDto[]
): string[] =>
  metadata
    .find((m) => m.baseSignalName === baseSignalName)
    ?.signals.map((s) => s.signalName) ?? [];

const findSignalPredicate =
  (signalName: string) => (signalReference: SignalReferenceDto) =>
    signalReference.signalName === signalName;

const findBaseSignalMetadata = (
  signalName: string,
  metadata: SignalMetadataDto[] | undefined
) => {
  return metadata?.find((meta) =>
    meta.signals.find(findSignalPredicate(signalName))
  );
};

export const getSignalMetaData = (
  signalName: string,
  metadata: SignalMetadataDto[] | undefined
) => {
  const baseSignalMetadata = findBaseSignalMetadata(signalName, metadata);
  const signalMetadata = baseSignalMetadata?.signals.find(
    findSignalPredicate(signalName)
  );

  return { baseSignalMetadata, signalMetadata };
};

export const getSignalPrecision = (
  signalName: string | undefined,
  metadata: SignalMetadataDto[] | undefined
) => {
  if (!signalName || !metadata) {
    return undefined;
  }

  const precision = findBaseSignalMetadata(signalName, metadata)?.precision;

  switch (precision) {
    case 'low':
    case 'medium':
    case 'high':
      return precision;
    case 'unknown':
    case undefined:
    default:
      return undefined;
  }
};
